import React, { useRef } from "react";

/* plugin */
import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";
/* plugin end */

/* component */
import animationData from "../../assests/json/info.json";
import Header from "../../components/Header";
import InnerBgComp from "../../components/InnerBgComp";
/* component end */

const RESPONSIBLE_LENDING_URL = "https://www.creditstar.co.uk/responsible-lending/";

const Rejected = () => {
  const isSoftReject = localStorage.getItem("preScoringDecision") === "declined";

  /* animation */
  const loaderAnim = useRef(null);
  const animPlay = () => {
    loaderAnim.current.play();
    localStorage.removeItem("currentStep");
  };
  /* animation end */

  return (
    <div>
      {/* Header Starts */}
      <Header colorLogo={true} />
      {/* Header Ends */}

      {/* Main Container Starts */}
      <div className="main-container">
        <InnerBgComp classes={"inner-bg-img add-bg-mob"} />
        <div className="container">
          {/* start */}
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="comm-box congo-box"
            style={isSoftReject ? { maxWidth: 640 } : undefined}
          >
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className={`congo-lottie${isSoftReject ? "" : " mb0"}`}
              style={isSoftReject ? { marginBottom: 48 } : undefined}
            >
              {isSoftReject ? (
                <AlertCircleIcon />
              ) : (
                <Player
                  onEvent={(event) => {
                    if (event === "load") {
                      animPlay();
                    }
                  }}
                  ref={loaderAnim}
                  autoplay={true}
                  loop={true}
                  src={animationData}
                />
              )}
            </motion.div>

            {isSoftReject ? (
              <SoftRejectContent />
            ) : (
              <HardRejectContent />
            )}
          </motion.div>
          {/* end */}
        </div>
      </div>
      {/* Main Container Ends */}
    </div>
  );
};

const HardRejectContent = () => (
  <div className="congo-cont">
    <motion.h4
      initial={{ y: 60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="congo-hdn"
    >
      We&rsquo;re sorry
    </motion.h4>
    <motion.div
      initial={{ y: 60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="congo-para"
    >
      <p>
        Unfortunately on this occasion your loan application has been
        unsuccessful.
        <br />
        Please feel free to apply again on{" "}
        {localStorage.getItem("coolDownDate")}.
      </p>
    </motion.div>
  </div>
);

// Figma-exported alert icon used on the soft-rejection screen.
const AlertCircleIcon = () => (
  <svg
    width="82"
    height="82"
    viewBox="0 0 82 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{ display: "block", margin: "0 auto" }}
  >
    <path
      d="M41 0.426758C63.4078 0.426758 81.5732 18.5922 81.5732 41C81.5732 63.4078 63.4078 81.5732 41 81.5732C18.5922 81.5732 0.426758 63.4078 0.426758 41C0.426758 18.5922 18.5922 0.426758 41 0.426758ZM41 6.40625C21.8944 6.40625 6.40625 21.8944 6.40625 41C6.40625 60.1056 21.8944 75.5938 41 75.5938C60.1056 75.5938 75.5938 60.1056 75.5938 41C75.5938 21.8944 60.1056 6.40625 41 6.40625ZM41 51.6768C43.5946 51.6768 45.6982 53.7804 45.6982 56.375C45.6982 58.9696 43.5946 61.0732 41 61.0732C38.4054 61.0732 36.3018 58.9696 36.3018 56.375C36.3018 53.7804 38.4054 51.6768 41 51.6768ZM39.5117 20.9268H42.4883C44.2126 20.9269 45.5792 22.3825 45.4717 24.1035L44.0908 46.2051C44.0486 46.8803 43.4881 47.4062 42.8115 47.4062H39.1885C38.5119 47.4062 37.9515 46.8803 37.9092 46.2051L36.5283 24.1035C36.4208 22.3824 37.7873 20.9268 39.5117 20.9268Z"
      fill="#00FFE4"
      stroke="white"
      strokeWidth="0.854167"
    />
  </svg>
);

const SoftRejectContent = () => (
  <div className="congo-cont" style={{ maxWidth: 540 }}>
    <motion.h4
      initial={{ y: 60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="congo-hdn"
      style={{ marginBottom: 10 }}
    >
      You&rsquo;re not eligible for a loan
    </motion.h4>
    <motion.div
      initial={{ y: 60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="congo-para"
      style={{ maxWidth: 520, margin: "0 auto" }}
    >
      <p style={{ fontSize: 14, lineHeight: "22px" }}>
        Based on the information provided, you don&rsquo;t currently meet our
        eligibility criteria for the loan.
      </p>
      <p style={{ fontSize: 14, lineHeight: "22px", marginTop: 12 }}>
        We apply these criteria to lend responsibly and protect our customers.
        You can learn more about how eligibility is assessed below.
      </p>
    </motion.div>

    <motion.a
      href={RESPONSIBLE_LENDING_URL}
      initial={{ y: 60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      className="button button--block"
      style={{ marginTop: 40 }}
    >
      Learn more
    </motion.a>
  </div>
);

export default Rejected;
